import { useQuery } from '@tanstack/react-query';
import { getAppConfiguration } from '@utils/browserEnv';
import { message } from 'antd';
import axios from 'axios';
import { TWO_HOURS_IN_MILLISECONDS } from 'mdc-constants';
import { useCallback, useEffect, useState } from 'react';
import { useAccessToken } from 'services';

const { cmsFullApiUrl } = getAppConfiguration();

export default function useUserFavorites(boatId?: number) {
  const [isFavourited, setIsFavourited] = useState<boolean>(false);
  const { data: accessToken } = useAccessToken();

  const {
    data: favoriteBoatsIds,
    isLoading: isLoadingFavorite,
    refetch: reFetchFavorite,
    isError,
    isSuccess,
  } = useQuery({
    queryKey: ['userFavoriteBoats'],
    queryFn: () =>
      axios
        .get(`${cmsFullApiUrl}/user-favorite-boat`, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: accessToken,
          },
        })
        .then((res) => res.data),

    enabled: !!accessToken,
    gcTime: TWO_HOURS_IN_MILLISECONDS,
    // onSuccess: (res) => {
    //   if (res.boats && boatId) {
    //     // check if is favorited
    //     return res.boats.find((item) => item.id === boatId) ? setIsFavourited(true) : setIsFavourited(false);
    //   }
    //   setIsFavourited(false);
    // },
    // onError: (_err) => {
    //   message.error('Error Getting All Favorite Boats');
    // },
  });

  // Switch to approach with useEffect to handle side effects because react-query v5 removed query callbacks
  useEffect(() => {
    if (isSuccess && favoriteBoatsIds.boats && boatId) {
      return favoriteBoatsIds.boats.find((item) => item.id === boatId) ? setIsFavourited(true) : setIsFavourited(false);
    }
    if (isError) {
      message.error('Error Getting All Favorite Boats');
    }
  }, [isSuccess, favoriteBoatsIds, boatId, isError]);

  const checkIsFavorite = useCallback(
    (id: number) => {
      if (accessToken && !isLoadingFavorite && favoriteBoatsIds?.boats?.length) {
        const checkFavorite = favoriteBoatsIds?.boats.find((favorite) => favorite.id === id);

        return checkFavorite ? true : false;
      }

      return false;
    },
    [accessToken, isLoadingFavorite, favoriteBoatsIds],
  );

  return {
    isLoadingFavorite,
    isFavourited,
    favoriteBoatsIds,
    reFetchFavorite,
    checkIsFavorite,
  };
}
